const defaultMobileBrands = () => {
	return ["Samsung", "Apple", "Xiaomi", "Oppo", "Vivo", "Huawei", "Sony"];
};

export default defaultMobileBrands;
